import { Star, ExternalLink } from "lucide-react";

// UPDATE THIS URL once Google Business Profile is set up:
// Replace with: https://www.google.com/maps/place/?q=place_id:YOUR_PLACE_ID
const GOOGLE_REVIEWS_URL = "https://www.google.com/search?q=Absolute+Landscapers+Mississauga+ON";
const GOOGLE_WRITE_REVIEW_URL = "https://www.google.com/search?q=Absolute+Landscapers+Mississauga+ON";

// Google "G" logo as SVG inline
const GoogleG = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);

// Full badge — used on Home page and Contact page
export function GoogleReviewsBadge() {
  return (
    <a
      href={GOOGLE_REVIEWS_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="google-reviews-badge"
      className="inline-flex items-center gap-4 bg-white border border-[#E2E8DF] rounded-2xl px-6 py-4 shadow-sm hover:shadow-md transition-all duration-200 hover:-translate-y-0.5 group"
    >
      {/* Google G */}
      <GoogleG size={36} />

      {/* Divider */}
      <div className="w-px h-10 bg-[#E2E8DF]" />

      {/* Rating info */}
      <div>
        <div className="flex items-center gap-1.5 mb-0.5">
          {[...Array(5)].map((_, i) => (
            <Star key={i} size={14} fill="#FBBC05" color="#FBBC05" />
          ))}
          <span
            className="text-[#1F291E] font-bold text-sm ml-1"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            5.0
          </span>
        </div>
        <p className="text-[#4A5D48] text-xs leading-tight">
          Rated on <span className="font-semibold text-[#1F291E]">Google Reviews</span>
        </p>
      </div>

      {/* Arrow */}
      <ExternalLink size={14} className="text-[#9aab97] group-hover:text-[#3a5c2e] transition-colors ml-1" />
    </a>
  );
}

// Write a Review CTA button
export function WriteReviewButton({ className = "" }) {
  return (
    <a
      href={GOOGLE_WRITE_REVIEW_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="write-review-btn"
      className={`inline-flex items-center gap-2 border-2 border-[#E2E8DF] hover:border-[#3a5c2e] text-[#4A5D48] hover:text-[#3a5c2e] rounded-xl px-5 py-2.5 text-sm font-medium transition-all duration-200 bg-white hover:shadow-sm ${className}`}
      style={{ fontFamily: "'Outfit', sans-serif" }}
    >
      <GoogleG size={16} />
      Write a Review
    </a>
  );
}

// Compact footer badge
export function GoogleReviewsFooterBadge() {
  return (
    <a
      href={GOOGLE_REVIEWS_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="google-reviews-footer-badge"
      className="inline-flex items-center gap-2.5 bg-white/10 hover:bg-white/15 border border-white/20 rounded-xl px-4 py-2.5 transition-all duration-200 group"
    >
      <GoogleG size={18} />
      <div>
        <div className="flex items-center gap-1">
          {[...Array(5)].map((_, i) => (
            <Star key={i} size={10} fill="#FBBC05" color="#FBBC05" />
          ))}
        </div>
        <p className="text-white/70 text-xs group-hover:text-white/90 transition-colors leading-tight mt-0.5">
          Google Reviews
        </p>
      </div>
    </a>
  );
}
